import { render, staticRenderFns } from "./article-search.vue?vue&type=template&id=d5ca5036&scoped=true"
import script from "./article-search.vue?vue&type=script&lang=js"
export * from "./article-search.vue?vue&type=script&lang=js"
import style0 from "./article-search.vue?vue&type=style&index=0&id=d5ca5036&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5ca5036",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5ca5036')) {
      api.createRecord('d5ca5036', component.options)
    } else {
      api.reload('d5ca5036', component.options)
    }
    module.hot.accept("./article-search.vue?vue&type=template&id=d5ca5036&scoped=true", function () {
      api.rerender('d5ca5036', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/article-search.vue"
export default component.exports